import { Component } from '@angular/core';

@Component({
  selector: 'app-localization-demo',
  standalone: false,
  templateUrl: './localization-demo.component.html',
  styleUrl: './localization-demo.component.scss',
})
export class LocalizationDemoComponent {}
